/* AramCrochet product gallery: prev/next arrows, a progress bar that follows the active image,
   thumbnail rail kept the same height as the main image, active thumb scrolled into view, swipe on touch. */
(function () {
  function init() {
    var main = document.querySelector('#MainContent .pc-pd-main-media');
    var rail = document.querySelector('#MainContent .pc-pd-thumbs-vert');
    if (!main || main.getAttribute('data-ac-gal')) return;
    main.setAttribute('data-ac-gal', '1');

    var slides = Array.prototype.slice.call(main.querySelectorAll('.pc-pd-slide'));
    var thumbs = rail ? Array.prototype.slice.call(rail.querySelectorAll('.pc-pd-thumb-btn')) : [];
    var n = slides.length;
    if (n < 2) return;

    function current() {
      for (var i = 0; i < n; i++) if (slides[i].classList.contains('is-active')) return i;
      return 0;
    }

    function go(i) {
      i = (i + n) % n;
      if (thumbs[i]) { thumbs[i].click(); return; }
      if (typeof window.pcSelectSlide === 'function') { window.pcSelectSlide(i, null); return; }
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      update();
    }

    /* arrows */
    function arrow(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ac-gal-arrow ac-gal-arrow--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Previous image' : 'Next image');
      b.innerHTML = dir === 'prev'
        ? '<svg viewBox="0 0 24 24" fill="none"><path d="M15 6l-6 6 6 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        : '<svg viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(current() + (dir === 'prev' ? -1 : 1)); });
      main.appendChild(b);
    }
    arrow('prev');
    arrow('next');

    /* progress bar */
    var bar = document.createElement('div');
    bar.className = 'ac-gal-bar';
    bar.setAttribute('aria-hidden', 'true');
    var fill = document.createElement('span');
    fill.className = 'ac-gal-bar__fill';
    fill.style.width = (100 / n) + '%';
    bar.appendChild(fill);
    main.insertAdjacentElement('afterend', bar);
    /* keep the bar under the main image even inside a flex row */
    var row = main.parentElement;
    if (row && getComputedStyle(row).display === 'flex' && getComputedStyle(row).flexDirection === 'row') {
      var wrap = document.createElement('div');
      wrap.className = 'ac-gal-mainwrap';
      wrap.style.cssText = 'flex:1 1 auto;min-width:0;display:flex;flex-direction:column;';
      row.insertBefore(wrap, main);
      wrap.appendChild(main);
      wrap.appendChild(bar);
      main.style.flex = 'none';
      main.style.width = '100%';
    }

    function update() {
      var i = current();
      fill.style.transform = 'translateX(' + (i * 100) + '%)';
      if (rail && thumbs[i]) {
        var t = thumbs[i];
        var top = t.offsetTop - rail.offsetTop;
        var target = top - (rail.clientHeight - t.offsetHeight) / 2;
        rail.scrollTo({ top: Math.max(0, target), behavior: 'smooth' });
      }
    }

    /* rail = same height as the main image, so it scrolls */
    function sizeRail() {
      if (!rail) return;
      var h = main.getBoundingClientRect().height;
      if (h > 0) rail.style.maxHeight = Math.round(h) + 'px';
    }

    /* react to any slide change (thumbs, arrows, the theme's own code) */
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(update);
      slides.forEach(function (s) { mo.observe(s, { attributes: true, attributeFilter: ['class'] }); });
    }

    /* swipe on touch screens */
    var x0 = null;
    main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(current() + (dx < 0 ? 1 : -1));
      x0 = null;
    });

    /* keyboard when the gallery has focus */
    main.setAttribute('tabindex', '0');
    main.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') go(current() - 1);
      if (e.key === 'ArrowRight') go(current() + 1);
    });

    sizeRail();
    update();
    window.addEventListener('resize', sizeRail);
    window.addEventListener('load', sizeRail);
    if ('ResizeObserver' in window) new ResizeObserver(sizeRail).observe(main);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
